<template>
    <div class="ban-modal wrapper">
        <Modal2
            v-if="internalBanModalVisible"
            :show-footer="false"
            class="ban-modal"
            :title="$t('message.banModalTitle')"
            @cancel="closeModal"
        >
            <table class="ban-table">
                <thead>
                    <tr>
                        <th>{{ $t("message.platform") }}</th>
                        <th>{{ $t("chatbotv2.value") }}</th>
                        <th>{{ $t("message.sendingAllow") }}</th>
                        <th>{{ $t("message.receiving") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="visitor-row">
                        <td class="icon-cell">
                            <img
                                src="https://static.supsis.live/common/email/supsisyazisislogo.png"
                                class="ban-modal-icon supsis-logo"
                                :class="{ disable: !visitor._id }"
                            />
                        </td>
                        <td>{{ visitor._id }}</td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="setVisitorSuppression('web-visitor', 'outbound', visitor._id, $event)"
                                :checked="getVisitorSuppression('web-visitor', 'outbound')"
                                :disabled="!visitor._id"
                            />
                        </td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="setVisitorSuppression('web-visitor', 'inbound', visitor._id, $event)"
                                :checked="getVisitorSuppression('web-visitor', 'inbound')"
                                :disabled="!visitor._id"
                            />
                        </td>
                    </tr>
                    <tr class="whatsapp-row">
                        <td class="icon-cell">
                            <whatsappIcon
                                color="#25D366"
                                class="ban-modal-icon"
                                :class="{ disable: !visitor.whatsappNumber }"
                            />
                        </td>
                        <td>{{ maskField('whatsappNumber', visitor.whatsappNumber) || $t("visitor.noWpNumber") }}</td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="setVisitorSuppression('whatsapp', 'outbound', visitor.whatsappNumber, $event)"
                                :checked="getVisitorSuppression('whatsapp', 'outbound')"
                                :disabled="!visitor.whatsappNumber"
                            />
                        </td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="setVisitorSuppression('whatsapp', 'inbound', visitor.whatsappNumber, $event)"
                                :checked="getVisitorSuppression('whatsapp', 'inbound')"
                                :disabled="!visitor.whatsappNumber"
                            />
                        </td>
                    </tr>
                    <tr class="instagram-row">
                        <td class="icon-cell">
                            <PlatformIcon :platform="'instagram'" :size="40" />
                        </td>
                        <td>{{ visitor.instagramUserId || "No Detail" }}</td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="
                                    setVisitorSuppression('instagram', 'outbound', visitor.instagramUserId, $event)
                                "
                                :checked="getVisitorSuppression('instagram', 'outbound')"
                                :disabled="!visitor.instagramUserId"
                            />
                        </td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="setVisitorSuppression('instagram', 'inbound', visitor.instagramUserId, $event)"
                                :checked="getVisitorSuppression('instagram', 'inbound')"
                                :disabled="!visitor.instagramUserId"
                            />
                        </td>
                    </tr>
                    <tr class="messenger-row">
                        <td class="icon-cell">
                            <PlatformIcon :platform="'messenger'" :size="40" />
                        </td>
                        <td>{{ visitor.messengerUserId || "No Detail" }}</td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="
                                    setVisitorSuppression('messenger', 'outbound', visitor.messengerUserId, $event)
                                "
                                :checked="getVisitorSuppression('messenger', 'outbound')"
                                :disabled="!visitor.messengerUserId"
                            />
                        </td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="setVisitorSuppression('messenger', 'inbound', visitor.messengerUserId, $event)"
                                :checked="getVisitorSuppression('messenger', 'inbound')"
                                :disabled="!visitor.messengerUserId"
                            />
                        </td>
                    </tr>
                    <tr class="mail-row">
                        <td class="icon-cell">
                            <gmail-icon class="ban-modal-icon" :class="{ disable: !visitor.email }" />
                        </td>
                        <td>{{ maskField('email', visitor.email) || $t("visitor.noEmail") }}</td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="setVisitorSuppression('email', 'outbound', visitor.email, $event)"
                                :checked="getVisitorSuppression('email', 'outbound')"
                                :disabled="!visitor.email"
                            />
                        </td>
                        <td>
                            <a-switch
                                class="ml-2 mr-2 switch"
                                un-checked-children="✔"
                                checked-children="✖"
                                @change="setVisitorSuppression('email', 'inbound', visitor.email, $event)"
                                :checked="getVisitorSuppression('email', 'inbound')"
                                :disabled="!visitor.email"
                            />
                        </td>
                    </tr>
<!--                    ip ban iplement edilmediği için yorum satırına aldım-->
<!--                    <tr class="ip-row">-->
<!--                        <td class="icon-cell">-->
<!--                            <webIcon color="black" class="ban-modal-icon" :class="{ disable: !visitor.ipAddress }" />-->
<!--                        </td>-->
<!--                        <td>{{ visitor.ipAddress || $t("visitor.noIpAddress") }}</td>-->
<!--                        <td>-->
<!--                            <a-switch-->
<!--                                class="ml-2 mr-2"-->
<!--                                un-checked-children="✔"-->
<!--                                checked-children="✖"-->
<!--                                @change="setVisitorSuppression('web-visitor-ip', 'outbound', visitor.ipAddress, $event)"-->
<!--                                :checked="getVisitorSuppression('web-visitor-ip', 'outbound')"-->
<!--                                :disabled="!visitor.ipAddress"-->
<!--                            />-->
<!--                        </td>-->
<!--                        <td>-->
<!--                            <a-switch-->
<!--                                class="ml-2 mr-2"-->
<!--                                un-checked-children="✔"-->
<!--                                checked-children="✖"-->
<!--                                @change="setVisitorSuppression('web-visitor-ip', 'inbound', visitor.ipAddress, $event)"-->
<!--                                :checked="getVisitorSuppression('web-visitor-ip', 'inbound')"-->
<!--                                :disabled="!visitor.ipAddress"-->
<!--                            />-->
<!--                        </td>-->
<!--                    </tr>-->
                </tbody>
            </table>
        </Modal2>
    </div>
</template>
<script>
import gmailIcon from "../views/Pages/Mail/icons/MailIcon.vue";
import whatsappIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import webIcon from "../views/Pages/Visitors/components/svg/WebIcon.vue";
import Modal2 from "./common/Modal2.vue";
import { SUPPRESSION_API } from "../api/suppression";
import { mapState, mapActions } from "vuex";
import { sendSocketMessage } from "../utils/socketStream";
import { maskContactInfo, isMaskContactInfo } from "../utils/utils";
import PlatformIcon from "./popup-chat/chat-window/ChatMessageArea/components/PlatformIcon.vue";

export default {
    name: "VisitorBanModal",
    components: { PlatformIcon, Modal2, webIcon, whatsappIcon, gmailIcon },
    props: ["visitor", "banModalVisible"],
    data() {
        return {
            internalBanModalVisible: false,
            visitorSuppression: {},
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        isMaskContactInfo,
        maskField(key, val) {
            return isMaskContactInfo(key) ? maskContactInfo(val) : val;
        },
        ...mapActions({
            updateContactFields: "contact/updateContactFields",
        }),
        async suppressionProcess(type, direction, value, status) {
            const suppression = {
                ...(this.visitorSuppression[type] || {}),
                [direction]: status,
            };

            if (!suppression?.outbound && !suppression?.inbound) {
                await SUPPRESSION_API.remove(type, value);
            } else {
                await SUPPRESSION_API.update(
                    type,
                    value,
                    !!suppression?.inbound,
                    !!suppression?.outbound,
                    this.user._id
                );
            }
        },
        getVisitorSuppression(type, direction) {
            return !!this.visitorSuppression[type]?.[direction];
        },
        async setVisitorSuppression(type, direction, key, value) {
            await this.suppressionProcess(type, direction, key, value);
            
            const updatedSuppression = {
                ...this.visitorSuppression,
                [type]: {
                    ...this.visitorSuppression[type],
                    [direction]: value,
                },
            };
            
            this.visitorSuppression = updatedSuppression;
            
            this.updateContactFields({
                contactId: this.visitor._id,
                set: {
                    suppression: updatedSuppression,
                },
            });
            
            this.$emit("changed", updatedSuppression);
            
            sendSocketMessage("visitor profile-updated", {
                siteId: this.site._id,
                visitorId: this.visitor._id,
                userId: this.user._id,
                updatingFields: {
                    suppression: updatedSuppression,
                },
            });
        },
        closeModal() {
            this.internalBanModalVisible = false;
            this.$emit("close");
        },
    },
    async mounted() {
        if (this.visitor) {
            this.visitorSuppression = this.visitor.suppression || {};
        }
    },
    watch: {
        banModalVisible: {
            immediate: true,
            handler(val) {
                this.internalBanModalVisible = val;
            },
        },
        visitor: {
            deep: true,
            handler() {
                this.visitorSuppression = this.visitor.suppression || {};
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.supsis-logo {
    width: 42px !important;
    height: 42px !important;
    object-fit: contain;
}

.icon-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
}

.ban-modal-icon {
    width: 40px;
    height: 40px;
    object-fit: contain;
}
</style>
<style lang="scss">
.ban-modal {
    .ant-modal-mask {
        z-index: 99999 !important;
    }

    .ant-modal-wrap {
        z-index: 99999 !important;
    }
}
</style>
